export type PermissionKey = string;

export type PermissionsMap = Record<PermissionKey, boolean>;

const STORAGE_KEY = "operatorv4:permissions";

const readPermissions = (): PermissionsMap => {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return {};

    try {
        const parsed = JSON.parse(raw);
        return parsed && typeof parsed === "object"
            ? (parsed as PermissionsMap)
            : {};
    } catch {
        return {};
    }
};

const writePermissions = (map: PermissionsMap) => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(map));
};

export const permissionsHelper = {
    setAll(map: PermissionsMap) {
        writePermissions(map);
    },

    get(key: PermissionKey, defaultValue = false): boolean {
        const map = readPermissions();
        return map[key] ?? defaultValue;
    },

    has(key: PermissionKey): boolean {
        const map = readPermissions();
        return !!map[key];
    },

    set(key: PermissionKey, value: boolean) {
        const map = readPermissions();
        map[key] = value;
        writePermissions(map);
    },

    clear(key?: PermissionKey) {
        if (!key) {
            localStorage.removeItem(STORAGE_KEY);
            return;
        }

        const map = readPermissions();
        delete map[key];
        writePermissions(map);
    },

    all(): PermissionsMap {
        return readPermissions();
    },
};